/* =============================================================
   RANZEN KIDS — Product Page JS
   ============================================================= */

(function () {
  'use strict';

  /* ---- GALLERY --------------------------------------------- */
    function initGallery(wrapper) {
    var mainWrap = wrapper.querySelector('[data-gallery-main]');
    var track = wrapper.querySelector('[data-gallery-track]');
    var slides = wrapper.querySelectorAll('[data-gallery-slide]');
    var thumbs = wrapper.querySelectorAll('[data-gallery-thumb]');

    if (!track || !slides.length) return;

    function updateActiveMediaType(index) {
      if (!mainWrap) return;
      var slide = slides[index];
      var isVideo = slide && slide.getAttribute('data-media-type') !== 'image';
      mainWrap.classList.toggle('is-video-active', !!isVideo);
    }

    function indexForMediaId(mediaId) {
      var idx = -1;
      slides.forEach(function (s, i) {
        if (s.getAttribute('data-media-id') === String(mediaId)) idx = i;
      });
      return idx;
    }

    function goToIndex(index, behavior) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'smooth' });
    }

      function setActiveThumb(index) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
      });
      updateActiveMediaType(index);
    }

    /* Click en thumbnail -> desliza el track hasta ese slide */
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goToIndex(i);
      });
    });

        /* Mientras el usuario arrastra/scrollea el track, sincroniza el thumbnail activo.
       Se calcula por aritmética (scrollLeft / ancho del track) en vez de medir cada
       slide con getBoundingClientRect, evitando forzar recálculos de layout en cada frame. */
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var slideWidth = track.clientWidth;
        var closestIdx = slideWidth ? Math.round(track.scrollLeft / slideWidth) : 0;
        closestIdx = Math.max(0, Math.min(closestIdx, slides.length - 1));

        setActiveThumb(closestIdx);
        ticking = false;
      });
    }, { passive: true });

      /* Usado por el variant picker para saltar a la imagen del color seleccionado */
    wrapper.selectGalleryMediaId = function (mediaId) {
      var idx = indexForMediaId(mediaId);
      if (idx >= 0) goToIndex(idx, 'auto');
    };

    updateActiveMediaType(0);
  }

  /* ---- QUANTITY SELECTOR ----------------------------------- */
  function initQuantity(wrapper) {
    var minusBtn = wrapper.querySelector('[data-qty-minus]');
    var plusBtn = wrapper.querySelector('[data-qty-plus]');
    var input = wrapper.querySelector('[data-qty-input]');

    if (!input) return;

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      });
    }

    input.addEventListener('change', function () {
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) input.value = 1;
    });
  }

  /* ---- VARIANT PICKER -------------------------------------- */
  function initVariants(wrapper) {
    var variantData = wrapper.querySelector('[data-variant-json]');
    if (!variantData) return;

    var variants;
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (e) {
      return;
    }

    if (!variants || !variants.length) return;

    var optionGroups  = wrapper.querySelectorAll('[data-option-index]');
    var variantIdInput = wrapper.querySelector('[data-variant-id]');
    var priceEl       = wrapper.querySelector('[data-product-price]');
    var compareEl     = wrapper.querySelector('[data-product-compare-price]');
    var savingsEl     = wrapper.querySelector('[data-product-savings]');
    var installmentsWrap = wrapper.querySelector('[data-installments-wrapper]');
    var installmentEl = wrapper.querySelector('[data-product-installment-amount]');
   var atcBtn        = wrapper.querySelector('[data-atc-btn]');
    var atcBtnText    = wrapper.querySelector('[data-atc-btn-text]');
    var buynowBtn     = wrapper.querySelector('[data-buynow-btn]');
    var buynowBtnText = wrapper.querySelector('[data-buynow-btn-text]');
    var stockBadgeEl      = wrapper.querySelector('[data-stock-badge]');
    var stockBadgeCountEl = wrapper.querySelector('[data-stock-badge-count]');

        /* Find variant by selected option values */
    function findVariantByOptions(selectedOptions) {
      if (!selectedOptions.length) return variants[0] || null;
      return variants.find(function (v) {
        return selectedOptions.every(function (opt, i) {
          return opt !== null && v.options[i] === opt;
        });
      }) || null;
    }

    function getSelectedOptions() {
      var opts = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.rz-variant-btn.is-active');
        opts.push(active ? active.getAttribute('data-value') : null);
      });
      return opts;
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return '$\u00a0' + amount;
    }

    function getInstallmentsCount() {
      if (!installmentsWrap) return 12;
      var count = parseInt(installmentsWrap.getAttribute('data-installments-count') || '12', 10);
      return (isNaN(count) || count < 1) ? 12 : count;
    }

    function formatInstallment(cents, count) {
      var amount = (cents / 100) / count;
      var rounded = Math.round(amount * 10) / 10;
      var text = (rounded % 1 === 0) ? String(Math.round(rounded)) : rounded.toFixed(1);
      return '$' + text;
    }

    function updateUI(variant) {
      if (!variant) {
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.classList.add('rz-btn-atc--soldout');
        }
        if (atcBtnText) atcBtnText.textContent = 'Sin stock';
        return;
      }

       if (wrapper.selectGalleryMediaId) {
        wrapper.selectGalleryMediaId(variant.featured_media_id);
      }

      if (stockBadgeEl) {
        if (typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0) {
          stockBadgeEl.style.display = '';
          if (stockBadgeCountEl) stockBadgeCountEl.textContent = variant.inventory_quantity;
        } else {
          stockBadgeEl.style.display = 'none';
        }
      }

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (installmentEl) installmentEl.textContent = formatInstallment(variant.price, getInstallmentsCount());

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
          if (savingsEl) {
            var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            savingsEl.textContent = '-' + pct + '%';
            savingsEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (savingsEl) savingsEl.style.display = 'none';
        }
      }

     [atcBtn, buynowBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !variant.available;
        btn.classList.toggle('rz-btn-atc--soldout', !variant.available);
      });
      if (variant.available) {
        if (atcBtnText) atcBtnText.textContent = 'Agregar al Carrito';
        if (buynowBtnText) buynowBtnText.textContent = 'Comprar Ahora';
      } else {
        if (atcBtnText) atcBtnText.textContent = 'Sin stock';
        if (buynowBtnText) buynowBtnText.textContent = 'Sin stock';
      }
    }

    function updateAvailability() {
      var selectedOptions = getSelectedOptions();
      optionGroups.forEach(function (group, groupIdx) {
        var buttons = group.querySelectorAll('.rz-variant-btn');
        buttons.forEach(function (btn) {
          var testOptions = selectedOptions.slice();
          testOptions[groupIdx] = btn.getAttribute('data-value');
          var match = findVariantByOptions(testOptions);
          btn.classList.toggle('is-unavailable', !match);
        });
      });
    }

    /* Option button clicks */
    optionGroups.forEach(function (group, groupIdx) {
      var buttons = group.querySelectorAll('.rz-variant-btn');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          var labelEl = wrapper.querySelector('[data-option-label="' + groupIdx + '"]');
          if (labelEl) labelEl.textContent = btn.getAttribute('data-value');

          var variant = findVariantByOptions(getSelectedOptions());
          updateUI(variant);
          updateAvailability();
        });
      });
    });

    /* --- INIT ---
       The liquid already renders the correct button state and prices.
       We ONLY run updateAvailability() to style unavailable option buttons.
       updateUI() runs only on user variant clicks (above). */
    updateAvailability();
  }

  /* ---- ACCORDION ------------------------------------------- */
  function initAccordion(wrapper) {
    var toggles = wrapper.querySelectorAll('.rz-accordion__toggle');
    toggles.forEach(function (toggle) {
      var item = toggle.closest('.rz-accordion__item');
      if (!item) return;
      var body = item.querySelector('.rz-accordion__body');
      item.classList.add('is-open');
      if (body) body.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    });
  }

  /* ---- ADD TO CART (AJAX) ---------------------------------- */
  function initATC(wrapper) {
    var form = wrapper.querySelector('[data-atc-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-atc-btn]');
      var btnText = form.querySelector('[data-atc-btn-text]');
      if (!btn || btn.disabled) return;

      var variantId = form.querySelector('[data-variant-id]');
      var qtyInput  = form.querySelector('[data-qty-input]');
      if (!variantId || !variantId.value) return;

      var originalText = btnText ? btnText.textContent : '';
      btn.disabled = true;
      if (btnText) btnText.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: parseInt(variantId.value, 10),
          quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.id) {
            if (btnText) btnText.textContent = '¡Listo!';
            /* Fetch the full cart so the drawer can show item_count and re-render */
            return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                /*
                 * Dispatch 'cart:update' — the event name the theme's cart-drawer-component
                 * and component-cart-items both listen to (CartAddEvent.eventName).
                 * cart-drawer-component opens because it has [auto-open].
                 * component-cart-items re-fetches its section HTML since we don't pass sections.
                 */
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: { resource: cart, sourceId: '', data: { itemCount: cart.item_count } }
                }));
                setTimeout(function () {
                  btn.disabled = false;
                  if (btnText) btnText.textContent = originalText;
                }, 1500);
              });
          } else {
            btn.disabled = false;
            if (btnText) btnText.textContent = originalText;
          }
        })
        .catch(function () {
          btn.disabled = false;
          if (btnText) btnText.textContent = originalText;
        });
    });
  }

  /* ---- BUY NOW (checkout directo) ---------------------------- */
  function goToCheckout(wrapper) {
    var variantId = wrapper.querySelector('[data-variant-id]');
    var qtyInput  = wrapper.querySelector('[data-qty-input]');
    if (!variantId || !variantId.value) return;

    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: parseInt(variantId.value, 10),
        quantity: quantity
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.id) {
          window.location.href = '/checkout';
        }
      });
  }

  function initBuyNow(wrapper) {
    var buynowBtn = wrapper.querySelector('[data-buynow-btn]');
    if (!buynowBtn) return;

    buynowBtn.addEventListener('click', function () {
      if (buynowBtn.disabled) return;
      var label = buynowBtn.querySelector('[data-buynow-btn-text]');
      var original = label ? label.textContent : '';
      buynowBtn.disabled = true;
      if (label) label.textContent = 'Ya casi es tuyo...';
      goToCheckout(wrapper);
      setTimeout(function () {
        buynowBtn.disabled = false;
        if (label) label.textContent = original;
      }, 4000);
    });
  }


  /* ---- STICKY ATC (mobile) --------------------------------- */
  function initStickyATC(wrapper) {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

   var originalBtn  = wrapper.querySelector('[data-buynow-btn]');
    var stickyBtn    = bar.querySelector('[data-sticky-btn]');
    var stickyBtnText = bar.querySelector('[data-sticky-btn-text]');
    var reviewsRoot = document.querySelector('#ranzen-reviews');

    if (!originalBtn || !stickyBtn) return;

        var atcVisible     = true;   // assume visible until observer says otherwise
    var hasBeenVisible = false;  // se activa recién cuando el botón real fue visto al menos una vez
    var footerVisible = false;
    var judgeMeModalOpen = false;

    function isVisibleElement(element) {
      if (!element) return false;
      var styles = window.getComputedStyle(element);
      return styles.display !== 'none' && styles.visibility !== 'hidden' && styles.opacity !== '0';
    }

    function isJudgeMeModalVisible() {
      var selectors = [
        '.jdgm-modal',
        '.jdgm-write-rev-modal',
        '.jdgm-ask-question-form-wrapper',
        '.jdgm-rev-widg__form-wrapper',
        '.jdgm-popup-wrapper',
        '[class*="jdgm-modal"]',
        '[class*="jdgm"][role="dialog"]',
        '[id*="judgeme"][role="dialog"]'
      ];

      for (var i = 0; i < selectors.length; i += 1) {
        var matches = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < matches.length; j += 1) {
          if (isVisibleElement(matches[j])) return true;
        }
      }

      return false;
    }

        /* ----- visibility toggle ----- */
    function updateBarVisibility() {
      var show = hasBeenVisible && !atcVisible && !footerVisible && !judgeMeModalOpen;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function syncJudgeMeVisibility() {
      judgeMeModalOpen = isJudgeMeModalVisible();
      updateBarVisibility();
    }

        if ('IntersectionObserver' in window) {
      /* Watch original ATC button */
      new IntersectionObserver(function (entries) {
        atcVisible = entries[0].isIntersecting;
        if (atcVisible) hasBeenVisible = true;
        updateBarVisibility();
      }, { threshold: 0, rootMargin: '0px' }).observe(originalBtn);

      /* Watch page footer (hide sticky when user reaches bottom) */
      var footerEl = document.querySelector('#shopify-section-footer-group, footer.footer, .site-footer');
      if (footerEl) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          updateBarVisibility();
        }, { threshold: 0 }).observe(footerEl);
      }
    }

    if (reviewsRoot) {
      var judgeMeSyncQueued = false;
      var queueJudgeMeSync = function () {
        if (judgeMeSyncQueued) return;
        judgeMeSyncQueued = true;
        requestAnimationFrame(function () {
          judgeMeSyncQueued = false;
          syncJudgeMeVisibility();
        });
      };

      reviewsRoot.addEventListener('click', function (event) {
        if (!event.target.closest('[class*="jdgm"], [id*="judgeme"]')) return;
        setTimeout(queueJudgeMeSync, 50);
        setTimeout(queueJudgeMeSync, 250);
      });

      new MutationObserver(queueJudgeMeSync).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'open', 'aria-hidden']
      });

      syncJudgeMeVisibility();
    }

    /* ----- sync sticky button state from main button ----- */
    function syncStickyState() {
      var isSoldOut = originalBtn.classList.contains('rz-btn-atc--soldout');
      stickyBtn.disabled = isSoldOut;
      /* Only update text when NOT in the temporary "loading/disabled" state */
     if (!originalBtn.disabled || isSoldOut) {
        if (stickyBtnText) {
          stickyBtnText.textContent = isSoldOut ? 'Sin stock' : 'Comprar Ahora';
        }
      }
    }
    syncStickyState();

    /* Re-sync whenever main button state changes */
    new MutationObserver(syncStickyState).observe(originalBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    /* ----- sticky click: mismo flujo de "comprar ahora" ----- */
    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      if (stickyBtnText) stickyBtnText.textContent = 'Ya casi es tuyo...';
      goToCheckout(wrapper);
      setTimeout(syncStickyState, 4000);
    });
  }

  /* ---- INIT ------------------------------------------------ */
  function init() {
    var productWrapper = document.querySelector('[data-ranzen-product]');
    if (!productWrapper) return;

    var urgencyBox = productWrapper.querySelector('[data-product-urgency-box]');
    var urgencyUnits = productWrapper.querySelector('[data-product-urgency-units]');
    if (urgencyBox && urgencyUnits) {
      var min = parseInt(urgencyBox.getAttribute('data-urgency-min') || '3', 10);
      var max = parseInt(urgencyBox.getAttribute('data-urgency-max') || '7', 10);

      if (isNaN(min)) min = 3;
      if (isNaN(max)) max = 7;
      if (min > max) {
        var temp = min;
        min = max;
        max = temp;
      }

      urgencyUnits.textContent = String(Math.floor(Math.random() * (max - min + 1)) + min);
    }

   initGallery(productWrapper);
    initQuantity(productWrapper);
    initVariants(productWrapper);
    initAccordion(productWrapper);
    initATC(productWrapper);
    initBuyNow(productWrapper);
    initStickyATC(productWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();




document.addEventListener('DOMContentLoaded', function() {
  const toggle = document.querySelector('[data-shipping-toggle]');
  const body = document.querySelector('[data-shipping-body]');

  if (toggle && body) {
    toggle.addEventListener('click', function() {
      const isOpen = toggle.getAttribute('data-open') === 'true';
      
      if (isOpen) {
        body.style.display = 'none';
        toggle.setAttribute('data-open', 'false');
      } else {
        body.style.display = 'block';
        toggle.setAttribute('data-open', 'true');
      }
    });
  }
});